module.exports = __webpack_public_path__ + "static/media/footer.31c82948.svg";